<template>
  <div>
    <!-- 搜索框和添加按钮 -->
    <el-row :gutter="20" class="search-and-add-row">
      <el-col :span="8">
        <el-input v-model="searchForm.planName" placeholder="输入培训计划名称" clearable></el-input>
      </el-col>
      <el-col :span="8" class="search-and-add-buttons">
        <el-button type="primary" @click="fetchData">搜索</el-button>
        <el-button type="primary" @click="showAddPlanDialog" icon="el-icon-plus" style="margin-left: 10px">添加培训计划</el-button>
        <el-button type="primary" @click="showaddtest" icon="el-icon-plus" style="margin-left: 10px">添加考试</el-button>


      </el-col>
    </el-row>
<testadd v-show="showthis" :plans="plans1"
         :questions="questions"
         :organizationID="organizationID"
  @close="closeDialog" > </testadd>
    <!-- 培训计划列表 -->
    <el-table :data="plans" style="width: 100%" stripe>
      <el-table-column label="计划名称" prop="planName" :min-width="200"></el-table-column>
      <el-table-column label="所属机构" prop="organizationId" :min-width="150"></el-table-column>
      <el-table-column label="开始时间" prop="startDate" :min-width="200">
        <template v-slot="{ row }">
          {{ row.startDate ? formatDate(row.startDate) : '' }}
        </template>
      </el-table-column>
      <el-table-column label="结束时间" prop="endDate" :min-width="200">
        <template v-slot="{ row }">
          {{ row.endDate ? formatDate(row.endDate) : '' }}
        </template>
      </el-table-column>

      <el-table-column label="操作" :min-width="200">
        <template v-slot="{ row }">
          <el-button type="text" @click="editPlan(row)">编辑</el-button>
          <el-button type="text" @click="deletePlan(row)">删除</el-button>
          <!-- 点击播放按钮打开视频弹窗 -->
<!--          <el-button type="text" @click="playVideo(row)">播放视频</el-button>-->
        </template>
      </el-table-column>
    </el-table>

    <!-- 分页 -->
    <el-pagination
      v-if="totalCount > 0"
      :current-page="currentPage"
      :page-size="pageSize"
      :total="totalCount"
      layout="total, prev, pager, next, jumper"
      @current-change="handlePageChange"
    ></el-pagination>

    <!-- 添加或编辑培训计划弹框 -->
    <el-dialog v-model="dialogVisible" :title="isEditMode ? '编辑培训计划' : '添加培训计划'">
      <el-form :model="newPlan" label-width="120px" class="form form-container">
        <!-- 计划名称 -->
        <el-form-item label="计划名称">
          <el-input v-model="newPlan.planName" placeholder="请输入计划名称"></el-input>
        </el-form-item>
<!--        v-for="video in (isEditMode ? videoList : newPlan.selectedVideos)"-->
<el-form-item label="选择视频">
  <el-checkbox-group v-model="newPlan.selectedVideos">
    <el-row :gutter="20">
      <el-col

        v-for="video   in  videoList "
        :key="video.id"
        :span="6"
        class="video-col"
      >
        <el-checkbox :label="video.id">
          <div class="video-wrapper">
            <!-- 使用 video 标签展示视频，并添加点击事件 -->
            <video :src="video.videoPath" controls class="video" @click="enterFullscreen($event)"></video>
            <span class="video-name">{{ video.videoName }}</span> <!-- 显示视频名称 -->
          </div>
        </el-checkbox>
      </el-col>
    </el-row>
  </el-checkbox-group>
</el-form-item>


        <!-- 开始时间 -->
        <el-form-item label="开始时间">
          <el-date-picker v-model="newPlan.startDate" type="date" placeholder="选择开始时间"></el-date-picker>
        </el-form-item>

        <!-- 结束时间 -->
        <el-form-item label="结束时间">
          <el-date-picker v-model="newPlan.endDate" type="date" placeholder="选择结束时间"></el-date-picker>
        </el-form-item>
      </el-form>

      <div slot="footer" class="dialog-footer">
        <el-button @click="dialogVisible = false">取 消</el-button>
        <el-button type="primary" @click="savePlan">确 定</el-button>
      </div>
    </el-dialog>


  </div>
</template>

<script>
import axios from '@/axios'; // 引入 axios 库用于发送请求
import { ElMessage } from 'element-plus';
import testadd from '@/components/ManageView/TestView.vue'
export default {

  components:{
    testadd
  },
  props: {
    userid: {
      type: Number,
      required: true,
    },
    organizationID: {
      type: Number,
      required: true,
    },
  },
  data() {
    return {
      plans1:[],//没有考试的计划
      questions :[
     ],
      showthis:false,
        currentComponent: null,  // 当前显示的组件
      plans: [],
      totalCount: 0,
      currentPage: 1,
      pageSize: 10,
      searchForm: {
        planName: ''
      },
      videoList: [],
      newPlan: {
        planName: '',
        selectedVideos: [],
        startDate: '',
        endDate: ''
      },
      dialogVisible: false,
      videoDialogVisible: false,
      currentVideoUrl: '',
      isEditMode: false,  // 用于区分添加和编辑
      editingPlanId: null, // 当前编辑的计划ID
    };
  },
  methods: {
    handlePageChange(newPage){

      this.currentPage = newPage;
      this.fetchData();
    },
    showaddtest(){
this.showthis=true
        this.currentComponent = testadd;  // 设置要显示的组件
    },
     closeDialog() {
      this.showthis = false; // 关闭对话框
       this.getplans1()
    },
    // 查询数据
fetchData() {
  const params = {
    OrganizationID: this.organizationID,
    planName: this.searchForm.planName,
    page: this.currentPage,
    size: this.pageSize
  };

  axios.get('/Manage/plans', { params })
    .then(response => {
      const { data } = response;
      this.plans = data.data;
      this.totalCount = data.total;
      ElMessage.success('数据加载成功');
    })
    .catch(error => {
      console.error('获取培训计划失败:', error);
      ElMessage.error('获取数据失败');
    });
},

savePlan() {
  if(this.newPlan.planName==='')
    return ElMessage.error('请输入计划名称');
  if(this.newPlan.selectedVideos.length===0)
    return ElMessage.error('请选择视频');
  if(this.newPlan.startDate==='')
    return ElMessage.error('请选择开始时间');
  if(this.newPlan.endDate==='')
    return ElMessage.error('请选择结束时间');
  if(this.newPlan.startDate>this.newPlan.endDate)
    return ElMessage.error('开始时间不能大于结束时间');
  if (this.isEditMode) {
    var filter = this.plans.filter(item => item.planId === this.editingPlanId);
   console.log(filter)

    if(    filter[0].organizationId===1) {
      return ElMessage.error('超级管理员的计划不可修改');
    }
    this.newPlan.organizationId = this.organizationID;
       this.newPlan.ids = this.newPlan.selectedVideos;
    // 编辑计划
    axios.put('/Manage/plans', this.newPlan)
      .then(response => {
        this.dialogVisible = false;
        this.fetchData(); // 刷新数据
        ElMessage.success('编辑培训计划成功');
      })
      .catch(error => {
        console.error('编辑培训计划失败:', error);
        ElMessage.error('编辑培训计划失败');
      });
  } else {




    // 添加新计划
    this.newPlan.organizationId = this.organizationID
    this.newPlan.ids = this.newPlan.selectedVideos;
    axios.post('/Manage/plans', this.newPlan)
      .then(response => {
        this.dialogVisible = false;
        this.fetchData(); // 刷新数据
        ElMessage.success('添加培训计划成功');
      })
      .catch(error => {
        console.error('添加培训计划失败:', error);
        ElMessage.error('添加培训计划失败');
      });
  }
},
  formatDate(date) {
    return new Date(date).toLocaleString(); // 确保 date 有效
  },
    playVideo(row) {
      this.currentVideoUrl = row.videoUrl;
      this.videoDialogVisible = true;
    },
    showAddPlanDialog() {
      this.isEditMode = false; // 添加模式
      this.newPlan = {
        planName: '',
        selectedVideos: [],
        startDate: '',
        endDate: ''
      };
      this.dialogVisible = true;
    },
    editPlan(row) {
      this.isEditMode = true; // 编辑模式
      this.editingPlanId = row.planId;
 const selectedVideoIds = row.videos.map(video => video.id);

      console.log(row.videos)
      this.newPlan = {
        planId: row.planId,
        planName: row.planName,
        selectedVideos: selectedVideoIds, // 假设视频存储在计划中
        startDate: row.startDate,
        endDate: row.endDate
      };
      this.dialogVisible = true;

      console.log(this.newPlan)
    },
  deletePlan(row) {
  axios.delete(`/Manage/plans/${row.planId}`)
    .then(response => {
      if(response.data.success) {
        this.fetchData(); // 刷新数据
        ElMessage.success('删除培训计划成功');
      }
      else {
        ElMessage.error(response.data.errorMsg);
      }
    })
    .catch(error => {
      console.error('删除培训计划失败:', error);
      ElMessage.error('删除培训计划失败');
    });
},

    // 进入全屏模式
    enterFullscreen(event) {
      const videoElement = event.target;
      if (videoElement.requestFullscreen) {
        videoElement.requestFullscreen();
      } else if (videoElement.mozRequestFullScreen) { // Firefox
        videoElement.mozRequestFullScreen();
      } else if (videoElement.webkitRequestFullscreen) { // Chrome, Safari and Opera
        videoElement.webkitRequestFullscreen();
      } else if (videoElement.msRequestFullscreen) { // IE/Edge
        videoElement.msRequestFullscreen();
      }
    },
    getplans1(){

      axios.get('/Manage/plans1',{params:{
          OrganizationID:this.organizationID
        }}).then(response => {
        if(response.data.success)
          this.plans1=response.data.data;
        else {
          ElMessage.error(response.data.errorMsg);
        }
      }).catch(error => {
        ElMessage.error("获取计划列表失败");
      })
    }
  },
  created() {
    this.fetchData(); // 页面加载时获取数据
    axios.get('/videos/all',
        {params:{organizationId:this.organizationID}}
    )
      .then(res => {
        this.videoList = res.data.data;
      })
      .catch(error => {
        console.error("获取视频列表失败:", error);
      });

    axios.get('/Manage/questions', { params: { OrganizationID: this.organizationID } })
        .then(response => {
          if(response.data.success)
          this.questions = response.data.data;
          else {
            ElMessage.error(response.data.errorMsg);
          }
        })

this.getplans1()
    console.log(this.userid)
    console.log(this.organizationID)
  }
};
</script>

<style scoped>
/* 其他样式保持不变 */
</style>

<style scoped>
.el-form-item {
  margin-bottom: 30px; /* 增大表单项之间的间距 */
}

.el-form-item.video-form-item {
  margin-top: 30px;
  margin-bottom: 30px;
}

.video-col {
  display: flex; /* 保证每个视频占据一个列 */
  flex-direction: column;
  align-items: center;
  padding: 10px;
  margin-bottom: 30px; /* 增大上下空隙 */
}

.form-container {
  max-width: 800px;
  margin: 30px auto;
  background: #f9f9f9;
  padding: 20px;
  border-radius: 10px;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
}

.video-wrapper {
  display: flex;
  flex-direction: column;
  align-items: center;
  background: #fff;
  padding: 10px;
  border-radius: 5px;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
  transition: transform 0.2s;
  margin: 20px; /* 确保每个视频卡片周围都有空隙 */
}

.video-wrapper:hover {
  transform: scale(1.05);
}

.video {
  width: 100%;
  height: auto;
  margin-bottom: 10px; /* 增大视频下方的间隙 */
  border-radius: 5px;
  cursor: pointer; /* 增加鼠标指针变化，表示视频可点击 */
}

.video-name {
  font-size: 14px;
  color: #333;
  text-align: center;
  margin-top: 5px; /* 增大视频名称上方的间隙 */
}
</style>
